/**
 * 设备能力集配置
 */

/**
 * 设备能力集初始化配置
 */
let G_DEVICE_CFG = {
    area:'AIS', //区域码 [AIS TRUE]
    userType:0, //用户权限 [user admin]
    isBridge:false, //是否桥接模式 
    wlNum:2, //无线个数 [0,1,2] 没有 单频2.4G 双频
    userNum:1, //USB个数
    lanNum:5, //LAN口个数 
    br0IP:'192.168.1.1', //br0 IP
    mac:'',
    language:'en',
    isSubRouter: false, // 子路由模式,
    isFindSubRouter:false, // 是否有子路由连接成功
    isWlBandSteering:false, //无线双频合一模式
    isReadOnly:false, // 配置项是否只读 （巴西Brisanet 需求）
}


/**
 * 初始化错误，提示退出登录
 * @param {*} vm 
 */
function initFaild (vm,errInfo){
    //清除 cookie
    cookie.clear()
    vm.$alert(errInfo, 'Device initialization failed', {
        type:'error',
        confirmButtonText: 'Confirm',
        callback: action => {
            //导航到登录页
            vm.$router.push('/')
        }
    })
}


/** 
 * 初始化
*/
function init (vm,callback){
    let loadingInstance = vm.$loading({
        lock: true,
    })
    axios
    .post("/boafrm/deviceConfig")
    .then((response)=>{
        loadingInstance.close()
        if(response.data.ret === 0)
        {
            G_DEVICE_CFG = response.data.devConfig
            G_DEVICE_CFG.userType = cookie.getItem('userType')

            if(G_DEVICE_CFG.area !== 'BRISANET' || G_DEVICE_CFG.userType === '1')
            {// 只有巴西Brisanet 普通用户 需要页面只读状态，其他不需要 默认配置为false
                G_DEVICE_CFG.isReadOnly = false
            }
            if(arguments.length > 1) callback()     
        }
        else
        {
            initFaild(vm,`Please log in again! Error message:${response.data.errMsg}`)
        }
    })
    .catch( (error) =>{
        loadingInstance.close()
    })
}

/**
 * 更新参数
 */
function update (deviceConfig){
    if(deviceConfig)
    {
        G_DEVICE_CFG = deviceConfig
    }
    else
    {
        axios
        .post("/boafrm/deviceConfig")
        .then((response)=>{
            if(response.data.ret === 0)
            {
                G_DEVICE_CFG = response.data.deviceConfig
            }
        })
    }
    
}

function getData() {
    return G_DEVICE_CFG;
}

export default {
    getData,
    init,
    update
}